export enum DYNAMO_DB_TABLES {
  profiles = 'prod_Profiles',
  latestUpdates = 'prod_LatestUpdates',
  objectTemplates = 'prod_ObjectTemplates',
  customerObjects = 'prod_CustomerObjects',
}
